/**
 * Re-usable selectors for grabbing API info out of the Redux store.
 */

import { createSelector } from 'reselect';

import { initialState } from '../reducers/apiReducer';

/**
 * Selects the api state out of the redux store.
 * Used internally in this file only. Although it is exported if you really want to use it.
 */
const selectApiState = (state) => state.api || initialState;

/**
 * Selects the available API's out of the redux store.
 */
const selectAvailableApis = createSelector(selectApiState, (apiState) => apiState.availableApis);

/**
 * Selects the currently chosen API out of the redux store.
 */
const selectCurrentApi = createSelector(selectApiState, (apiState) => {
	const currentApiId = apiState.currentApiId;

	if (currentApiId) {
		const available = apiState.availableApis;
		return available.find((api) => api.id === currentApiId);
	}

	return null;
});

export { selectApiState, selectAvailableApis, selectCurrentApi };
